import {WorkflowStepsBaseService} from 'app/core/workflow/workflow-steps/workflow-steps-base.service';
import { TaxCardSpouseComponentPath } from 'app/core/workflow/page-path/statement-page-path/tax-card-spouse-component.path';
import { B2bTaxCardSpouseComponentPath } from 'app/core/workflow/page-path/statement-page-path/b2b.tax-card-spouse-component.path';

export class WorkflowTaxCardSpouseService extends WorkflowStepsBaseService {
  public get isRequired(): boolean {
    return this.hasSpouseAndFilledTogether;
  }

  public get isVisible(): boolean {
    return this.isRequired;
  }

  public get title(): string {
    if (this.isBusiness) {
      return 'ASIDE_BAR.SPOUSES_INCOME';
    }

    return 'ASIDE_BAR.SNAP';
  }

  public get isDone(): boolean {
    return this.statement && this.statement.spouse
      && this.isSpouseStageEmployerDone;
  }

  public get checkCanGo(): boolean {
    return !this.blockedDefaultWorkflow && this.isRequired && this.statement.spouse.stagePersonalInfo;
  }

  public get urlRegex(): RegExp {
    if (this.isBusiness) {
      return B2bTaxCardSpouseComponentPath.regex();
    }

    return TaxCardSpouseComponentPath.regex();
  }

  public get url(): string {
    if (this.isBusiness) {
      return B2bTaxCardSpouseComponentPath.url(this.getStatementId, this.getSpouseId, this.getEmployerId);
    }

    return TaxCardSpouseComponentPath.url(this.getStatementId, this.getSpouseId);
  }
}
